/* Builds the custom mobile menu (sections/mb_menu_cb.liquid) from the desktop header menu,
   so mobile shows exactly the same items, in the same order. */
(function () {
  var SEL = '[data-cb-menu-source="desktop"]:not([data-cb-built])';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function titleOf(a) {
    var c = a.cloneNode(true);
    c.querySelectorAll('svg, i, .t4s_lb_nav, .t4s-icon-select-arrow').forEach(function (n) { n.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function handleFromUrl(url, type) {
    var m = (url || '').match(new RegExp('/' + type + '/([^/?#]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function readDesktop() {
    var lis = document.querySelectorAll('#t4s-nav-ul > li');
    var items = [];
    lis.forEach(function (li) {
      var a = li.querySelector(':scope > a');
      if (!a) return;
      var lazy = li.querySelector('.t4s-lazy_menu[data-handle]');
      var subLinks = [];
      if (!lazy) {
        li.querySelectorAll('.t4s-sub-menu a[href]').forEach(function (s) {
          var t = titleOf(s); if (t) subLinks.push({ title: t, url: s.getAttribute('href'), links: [] });
        });
      }
      items.push({
        title: titleOf(a),
        url: (a.getAttribute('href') || '/').trim(),
        menu: lazy ? lazy.getAttribute('data-handle') : '',
        links: subLinks
      });
    });
    return items;
  }
  function render(nav, items, data) {
    var icon = (nav.querySelector('template[data-cb-icon]') || {}).innerHTML || '';
    var arrow = (nav.querySelector('template[data-cb-arrow]') || {}).innerHTML || '';
    var html = '';
    items.forEach(function (it) {
      var kids = it.menu && data['menu:' + it.menu] ? data['menu:' + it.menu] : it.links;
      var img = data['col:' + handleFromUrl(it.url, 'collections')] || null;
      var left = '<span class="cb-mm__left"><span class="cb-mm__icon">' +
        (img ? '<img src="' + esc(img) + '" width="24" height="24" alt="" loading="lazy">' : icon) +
        '</span><span class="cb-mm__label">' + esc(it.title) + '</span></span>';
      if (kids && kids.length) {
        html += '<details class="cb-mm__details"><summary class="cb-mm__summary">' + left + arrow + '</summary><div class="cb-mm__sub">';
        if (it.url && it.url !== '#') html += '<a href="' + esc(it.url) + '">View all ' + esc(it.title) + '</a>';
        kids.forEach(function (c) {
          if (c.links && c.links.length) {
            html += '<details><summary class="cb-mm__sub-summary"><span>' + esc(c.title) + '</span>' + arrow + '</summary><div class="cb-mm__sub"><a href="' + esc(c.url) + '">View all</a>';
            c.links.forEach(function (g) { html += '<a href="' + esc(g.url) + '">' + esc(g.title) + '</a>'; });
            html += '</div></details>';
          } else {
            html += '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
          }
        });
        html += '</div></details>';
      } else {
        html += '<a class="cb-mm__item" href="' + esc(it.url) + '">' + left + '</a>';
      }
    });
    var keep = nav.querySelectorAll('template');
    nav.innerHTML = html;
    keep.forEach(function (t) { nav.appendChild(t); });
  }
  function build(nav) {
    nav.setAttribute('data-cb-built', '1');
    var items = readDesktop();
    if (!items.length) return; /* no desktop menu found: keep the server-rendered fallback list */
    var tokens = [];
    items.forEach(function (it) {
      if (it.menu) tokens.push('menu:' + it.menu);
      var h = handleFromUrl(it.url, 'collections'); if (h) tokens.push('col:' + h);
    });
    render(nav, items, {});
    if (!tokens.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'search?view=cbmn&q=' + encodeURIComponent(tokens.join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { render(nav, items, JSON.parse(t)); })
      .catch(function () {});
  }
  function scan() { document.querySelectorAll(SEL).forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
